import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
  Separator,
} from '@predoc/cow';
import { MedicalRecordsSection } from './medical-records';
import { MedicationDataSection } from './medication-data';
import { NonMedicalDocumentsSection } from './non-medical-documents';
import { ProvidersSection } from './providers';
import { RequestsSection } from './requests';
import type { DocumentViewerData } from '../PatientProfile';

interface PatientDocumentsTabsProps {
  onViewDocument: (document: DocumentViewerData) => void;
}

export const PatientDocumentsTabs = ({
  onViewDocument,
}: PatientDocumentsTabsProps) => {
  return (
    <div className="rounded-lg border bg-white p-6">
      <Tabs defaultValue="medical-records">
        <TabsList>
          <TabsTrigger value="medical-records">Medical Records</TabsTrigger>
          <TabsTrigger value="medical-data">Medical Data</TabsTrigger>
          <TabsTrigger value="providers">Providers</TabsTrigger>
          <TabsTrigger value="non-medical">Non-Medical Documents</TabsTrigger>
          <TabsTrigger value="requests">Requests</TabsTrigger>
        </TabsList>
        <Separator />

        <TabsContent value="medical-records">
          <MedicalRecordsSection />
        </TabsContent>

        <TabsContent value="medical-data">
          <MedicationDataSection />
        </TabsContent>

        <TabsContent value="providers">
          <ProvidersSection />
        </TabsContent>

        <TabsContent value="non-medical">
          <NonMedicalDocumentsSection onViewDocument={onViewDocument} />
        </TabsContent>

        <TabsContent value="requests">
          <RequestsSection />
        </TabsContent>
      </Tabs>
    </div>
  );
};
